import React from 'react';
import { useNavigate } from 'react-router-dom';
import EditNoteIcon from '@mui/icons-material/EditNote';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';

interface UnsignedNote {
  note_id: string;
  note_title: string | null;
  is_signed: boolean;
}

interface UnsignedNotesModalProps {
  open: boolean;
  onClose: () => void;
  notes: UnsignedNote[];
  patientName: string;
}

export const UnsignedNotesModal: React.FC<UnsignedNotesModalProps> = ({
  open,
  onClose,
  notes,
  patientName,
}) => {
  const navigate = useNavigate();

  const unsignedNotes = notes.filter(note => !note.is_signed);

  const handleNoteClick = (noteId: string) => {
    navigate(`/note/${noteId}`);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Sign Notes for {patientName}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Select a note to sign:
        </Typography>
        <List>
          {unsignedNotes.map((note, index) => (
            <ListItem key={note.note_id} disablePadding>
              <ListItemButton onClick={() => handleNoteClick(note.note_id)}>
                <ListItemIcon>
                  <EditNoteIcon />
                </ListItemIcon>
                <ListItemText
                  primary={note.note_title || `Untitled Note ${index + 1}`}
                  secondary={`Note ID: ${note.note_id.slice(0, 8)}...`}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};